module.exports = __webpack_public_path__ + "img/xcx-case10.4f4ecae6.png";